"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.useStyles = void 0;

var React = _interopRequireWildcard(require("react"));

var _Barcodes = _interopRequireDefault(require("../barcode/Barcodes"));

var _AuxiliaryFields = _interopRequireDefault(require("../fields/AuxiliaryFields"));

var _SecondaryFields = _interopRequireDefault(require("../fields/SecondaryFields"));

var _LogoTextHeaderFields = _interopRequireDefault(require("./LogoTextHeaderFields"));

var _usePkpass2 = require("../usePkpass");

var _BoardingPassIcon = _interopRequireDefault(require("./BoardingPassIcon"));

var _types = require("../../../../types");

var _reactJss = require("react-jss");

var _Theme = require("../../Theme");

var _Field = _interopRequireDefault(require("../fields/field/preview/Field"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var useStyles = (0, _reactJss.createUseStyles)({
  containerBoardingPass: {
    display: 'table',
    height: function height(_ref) {
      var theme = _ref.theme;
      return theme.scale * 70;
    },
    tableLayout: 'fixed',
    width: function width(_ref2) {
      var theme = _ref2.theme;
      return theme.scale * 320;
    }
  },
  fieldContainer: {
    display: 'table-cell',
    verticalAlign: 'top'
  },
  iconContainer: {
    display: 'table-cell',
    textAlign: 'center',
    verticalAlign: 'middle',
    width: function width(_ref3) {
      var theme = _ref3.theme;
      return theme.scale * 70;
    },
    '&:hover': {
      cursor: function cursor(_ref4) {
        var clickable = _ref4.clickable;
        return clickable ? 'pointer' : undefined;
      },
      opacity: function opacity(_ref5) {
        var clickable = _ref5.clickable;
        return clickable ? 0.7 : undefined;
      }
    }
  }
});
exports.useStyles = useStyles;

var BoardingPass = function BoardingPass() {
  var _usePkpass = (0, _usePkpass2.usePkpass)(),
      pass = _usePkpass.pass,
      onBoardingPassIconClick = _usePkpass.onBoardingPassIconClick;

  var theme = (0, _Theme.useTheme)();
  var classes = useStyles({
    theme: theme,
    clickable: !!onBoardingPassIconClick
  });
  var primaryFields = pass.boardingPass.primaryFields || [];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_LogoTextHeaderFields.default, null), /*#__PURE__*/React.createElement("div", {
    className: classes.containerBoardingPass
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.fieldContainer
  }, primaryFields.length > 0 && /*#__PURE__*/React.createElement(_Field.default, {
    fieldsType: _types.PkpassFieldsType.PrimaryFields,
    fieldIndex: 0,
    align: "left"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.iconContainer,
    onClick: onBoardingPassIconClick
  }, /*#__PURE__*/React.createElement(_BoardingPassIcon.default, null)), /*#__PURE__*/React.createElement("div", {
    className: classes.fieldContainer
  }, primaryFields.length > 1 && /*#__PURE__*/React.createElement(_Field.default, {
    fieldsType: _types.PkpassFieldsType.PrimaryFields,
    fieldIndex: 1,
    align: "right"
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_AuxiliaryFields.default, null), /*#__PURE__*/React.createElement(_SecondaryFields.default, null)), /*#__PURE__*/React.createElement(_Barcodes.default, null));
};

var _default = BoardingPass;
exports.default = _default;
//# sourceMappingURL=BoardingPass.js.map